export default function parseFloat(val: any): undefined | number {
  if (typeof val === 'number') return val;

  const parsed = window.parseFloat(val);
  if (!Number.isNaN(parsed)) return parsed;

  return undefined;
}
